import { useLiveData, useService } from '@toeverything/infra';
import clsx from 'clsx';
import { useCallback, useEffect } from 'react';

import { ViewService } from '../../services/view';
import { WorkbenchService } from '../../services/workbench';
import { ViewSidebarTabBodyTarget } from '../view-islands';
import * as styles from './sidebar-container.css';
import { Header } from './sidebar-header';
import { SidebarHeaderSwitcher } from './sidebar-header-switcher';

export const SidebarContainer = ({
  className,
  ...props
}: React.HtmlHTMLAttributes<HTMLDivElement>) => {
  const workbenchService = useService(WorkbenchService);
  const workbench = workbenchService.workbench;
  const viewService = useService(ViewService);
  const view = viewService.view;
  const sidebarTabs = useLiveData(view.sidebarTabs$);
  const activeSidebarTab = useLiveData(view.activeSidebarTab$);

  const handleToggleOpen = useCallback(() => {
    workbench.toggleSidebar();
  }, [workbench]);

  useEffect(() => {
    if (activeSidebarTab?.id === 'outline') {
      setTimeout(() => {
        const panelNode = document.querySelector?.('affine-outline-panel')?.shadowRoot
        // 标题改为中文
        const panelHeaderNode = panelNode?.querySelector?.('affine-outline-panel-header')?.shadowRoot
        const tableOfContentTitleNode = panelHeaderNode?.querySelector?.('.outline-panel-header-label')
        if (tableOfContentTitleNode) tableOfContentTitleNode.innerHTML = '文档目录';
        // 空内容提示改为中文
        const panelBodyNode = panelNode?.querySelector?.('affine-outline-panel-body')?.shadowRoot
        const noPlaceholderTextNode = panelBodyNode?.querySelector?.('.note-placeholder')
        if (noPlaceholderTextNode) noPlaceholderTextNode.innerHTML = '使用标题以创建目录'
        // 设置按钮调整为中文
        const settingMenuNode = panelHeaderNode?.querySelector?.('affine-outline-note-preview-setting-menu')?.shadowRoot
        const activeLabelNode = settingMenuNode?.querySelector?.('.action-label')
        if (activeLabelNode) activeLabelNode.innerHTML = '显示标题图标'
      })
    }
  }, [activeSidebarTab]);

  return (
    <div className={clsx(styles.sidebarContainerInner, className)} {...props}>
      <Header onToggle={handleToggleOpen}>
        <SidebarHeaderSwitcher />
      </Header>
      {sidebarTabs.length > 0 ? (
        sidebarTabs.map(sidebar => (
          <ViewSidebarTabBodyTarget
            tabId={sidebar.id}
            key={sidebar.id}
            style={{ display: activeSidebarTab === sidebar ? 'block' : 'none' }}
            viewId={view.id}
            className={clsx(
              styles.sidebarBodyTarget,
              !BUILD_CONFIG.isElectron && styles.borderTop
            )}
            data-testid={`sidebar-tab-content-${sidebar.id}`}
          />
        ))
      ) : (
        <div className={styles.sidebarBodyNoSelection}>请打开文档后再与AI互动</div>
      )}
    </div>
  );
};
